/**
 * @功能名称:
 * @文件名称: mta.js
 * @Date: 2018/11/21 下午5:25.
 * @Author: pianruijie
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
import MtaH5 from 'mta-h5-analysis';

MtaH5.init({
  "sid":'500649722', //必填，统计用的appid
  "cid":'', //如果开启自定义事件，此项目为必填，否则不填
  "autoReport":1,//是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
  "senseHash":1, //hash锚点是否进入url统计
  "senseQuery":1, //url参数是否进入url统计
  "performanceMonitor":0,//是否开启性能监控
  "ignoreParams":[] //开启url参数上报时，可忽略部分参数拼接上报
});



// WEBPACK FOOTER //
// ./src/asset/vendor/mta.js